<template>
  <div class="molded-seat-step-four">
    <v-switch
      v-model="form.breastplate_module.idc_breastplate"
      hide-details
      label="Plastron :"
      class="title"
      @change="clearBreastplateFields"
    />
    <v-layout justify-space-between>
      <v-flex sm4>
        <v-radio-group
          v-model="form.breastplate_module.breastplate_type"
          hide-details
          :disabled="!form.breastplate_module.idc_breastplate"
        >
          <v-layout
            class="checkbox-input-container mb-4"
            align-center
          >
            <v-flex sm5>
              <v-radio
                label="Plastron"
                value="BREASTPLATE"
              />
            </v-flex>
            <v-flex class="checkbox-input visible">
              <v-select
                v-model="form.breastplate_module.breastplate"
                :items="breastPlateModule.breastplate"
                item-text="label"
                item-value="value"
                filled
                hide-details
                :disabled="!form.breastplate_module.idc_breastplate"
              />
            </v-flex>
          </v-layout>
          <v-layout
            class="checkbox-input-container"
            align-center
          >
            <v-flex sm5>
              <v-radio
                label="Boléro"
                value="BOLERO"
              />
            </v-flex>
            <v-flex
              sm6
              class="checkbox-input visible"
            >
              <v-select
                v-model="form.breastplate_module.size"
                :items="breastPlateModule.size"
                item-text="label"
                item-value="value"
                filled
                hide-details
                :disabled="!form.breastplate_module.idc_breastplate"
              />
            </v-flex>
          </v-layout>
        </v-radio-group>
      </v-flex>
      <v-flex sm5>
        <div class="content">
          <div class="img-container">
            <img src="@/assets/img/schema_otn_1a.svg">
            <v-text-field
              v-model="form.breastplate_module.a"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Plastron) A') }"
              data-vv-name="(Plastron) A"
              outlined
              type="number"
              style="top: 20.1%;left: 32.8%;"
              height="100%"
              :disabled="!form.breastplate_module.idc_breastplate"
            />
            <v-text-field
              v-model="form.breastplate_module.a"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Plastron) A') }"
              data-vv-name="(Plastron) A"
              outlined
              type="number"
              style="top: 20.1%;left: 80.4%;"
              height="100%"
              :disabled="!form.breastplate_module.idc_breastplate"
            />
            <v-text-field
              v-model="form.breastplate_module.b"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Plastron) B') }"
              data-vv-name="(Plastron) B"
              outlined
              type="number"
              style="top: 3%;left: 56.9%;"
              height="100%"
              :disabled="!form.breastplate_module.idc_breastplate"
            />
            <v-text-field
              v-model="form.breastplate_module.c"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Plastron) C') }"
              data-vv-name="(Plastron) C"
              outlined
              type="number"
              style="top: 44.3%;left: 72.3%;"
              height="100%"
              :disabled="!form.breastplate_module.idc_breastplate"
            />
            <v-text-field
              v-model="form.breastplate_module.d"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Plastron) D') }"
              data-vv-name="(Plastron) D"
              outlined
              type="number"
              style="top: 84.9%;left: 56.3%;"
              height="100%"
              :disabled="!form.breastplate_module.idc_breastplate"
            />
            <v-text-field
              v-model="form.breastplate_module.e"
              v-validate="'numeric|max:4'"
              :class="{ error: errors.has('(Plastron) E') }"
              data-vv-name="(Plastron) E"
              outlined
              type="number"
              style="top: 53.3%;left: 0.2%;"
              height="100%"
              :disabled="!form.breastplate_module.idc_breastplate"
            />
          </div>
        </div>
      </v-flex>
      <v-flex sm3>
        <v-radio-group
          v-model="form.breastplate_module.construction_type"
          hide-details
          :disabled="!form.breastplate_module.idc_breastplate"
        >
          <v-radio
            label="Gabarit"
            value="TEMPLATE"
          />
          <v-radio
            label="Sur mesures"
            value="CUSTOM_MADE"
          />
        </v-radio-group>
        <v-switch
          v-model="form.breastplate_module.idc_shoulder_socket"
          label="Réhausse épaule"
          hide-details
          :disabled="!form.breastplate_module.idc_breastplate"
        />
        <v-switch
          v-model="form.breastplate_module.idc_adjustment_cebelor"
          label="Réglage Cebelor"
          hide-details
          class="mt-0"
          :disabled="!form.breastplate_module.idc_breastplate"
        />
      </v-flex>
    </v-layout>

    <v-switch
      v-model="form.idc_adaptation_support"
      hide-details
      label="Adaptation au support :"
      class="title"
      @change="clearAdaptationFields"
    />
    <v-radio-group
      v-model="form.adaptation_support_type"
      row
      :disabled="!form.idc_adaptation_support"
    >
      <v-radio
        label="Fixe"
        value="FIXED"
      />
      <v-radio
        label="Amovible"
        value="REMOVABLE"
      />
    </v-radio-group>

    <v-simple-table class="mb-6">
      <thead>
        <tr>
          <th class="text-center" />
          <th class="text-center">
            Sangles
          </th>
          <th class="text-center">
            Bouton
          </th>
          <th class="text-center">
            Velcro
          </th>
          <th class="text-center">
            Poignée souple
          </th>
          <th class="text-center">
            Poignée rigide
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>Dossier</th>
          <td>
            <v-select
              v-model="form.adaptation_support_backrest_strap"
              :items="dropdowns.adaptation_support_backrest_strap"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
              :disabled="!form.idc_adaptation_support"
            />
          </td>
          <td>
            <v-checkbox
              v-model="form.idc_adaptation_support_backrest_button"
              class="justify-center mt-0"
              hide-details
              :disabled="!form.idc_adaptation_support"
            />
          </td>
          <td>
            <v-select
              v-model="form.adaptation_support_backrest_velcro"
              :items="dropdowns.adaptation_support_backrest_velcro"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
              :disabled="!form.idc_adaptation_support"
            />
          </td>

          <td>
            <v-checkbox
              v-model="form.idc_adaptation_support_backrest_flex"
              class="justify-center mt-0"
              hide-details
              :disabled="!form.idc_adaptation_support"
            />
          </td>
          <td>
            <v-checkbox
              v-model="form.idc_adaptation_support_backrest_rigid"
              class="justify-center mt-0"
              hide-details
              :disabled="!form.idc_adaptation_support"
            />
          </td>
        </tr>

        <tr>
          <th>Assise</th>
          <td>
            <v-select
              v-model="form.adaptation_support_seated_strap"
              :items="dropdowns.adaptation_support_seated_strap"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
              :disabled="!form.idc_adaptation_support"
            />
          </td>
          <td>
            <v-checkbox
              v-model="form.idc_adaptation_support_seated_button"
              class="justify-center mt-0"
              hide-details
              :disabled="!form.idc_adaptation_support"
            />
          </td>
          <td>
            <v-select
              v-model="form.adaptation_support_seated_velcro"
              :items="dropdowns.adaptation_support_seated_velcro"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
              hide-details
              :disabled="!form.idc_adaptation_support"
            />
          </td>
          <td>
            <v-checkbox
              v-model="form.idc_adaptation_support_seated_flex"
              class="justify-center mt-0"
              hide-details
              :disabled="!form.idc_adaptation_support"
            />
          </td>
          <td>
            <v-checkbox
              v-model="form.idc_adaptation_support_seated_rigid"
              class="justify-center mt-0"
              hide-details
              :disabled="!form.idc_adaptation_support"
            />
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <v-textarea
      v-model="form.adaptation_support_comment"
      filled
      name="Ajouter un commentaire :"
      label="Ajouter un commentaire :"
      :disabled="!form.idc_adaptation_support"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MoldedSeatStepFour",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      dropdowns: "dropdowns/getMoldedSeatOptions",
      breastPlateModule: "dropdowns/getBreastPlateOptions"
    })
  },
  created() {
    this.$validator = this.parentValidator;
  },
  methods: {
    // Clear breastplate fields
    clearBreastplateFields() {
      this.form.breastplate_module.breastplate = null;
      this.form.breastplate_module.breastplate_type = null;
      this.form.breastplate_module.size = null;
      this.form.breastplate_module.a = null;
      this.form.breastplate_module.b = null;
      this.form.breastplate_module.c = null;
      this.form.breastplate_module.d = null;
      this.form.breastplate_module.e = null;
      this.form.breastplate_module.construction_type = null;
      this.form.breastplate_module.idc_shoulder_socket = false;
      this.form.breastplate_module.idc_adjustment_cebelor = false;
    },

    // Clear adaptation fields
    clearAdaptationFields() {
      this.form.adaptation_support_type = null;
      this.form.adaptation_support_backrest_strap = null;
      this.form.idc_adaptation_support_backrest_button = false;
      this.form.adaptation_support_backrest_velcro = null;
      this.form.idc_adaptation_support_backrest_flex = false;
      this.form.idc_adaptation_support_backrest_rigid = false;
      this.form.adaptation_support_seated_strap = null;
      this.form.idc_adaptation_support_seated_button = false;
      this.form.idc_adaptation_support_seated_flex = false;
      this.form.idc_adaptation_support_seated_rigid = false;
      this.form.adaptation_support_comment = null;
    }
  }
};
</script>

<style lang="scss">
.molded-seat-step-four {
  .content {
    display: flex;
    //min-height: 80vh;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        //height: 100%;
        //width: 100%;
        //min-width: 800px;
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        width: 16.7%;
        height: 12.4%;
        @media (max-width: 800px) {
          height: 12.4%;
        }
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
          }
        }
      }
    }
  }
  .checkbox-input-container {
    margin-top: 0;
    > div {
      &.checkbox-input {
        position: relative;
        top: 0;
        transform: none;
        margin-left: 15px;
        max-width: none !important;
        &:not(.visible) {
          display: none;
        }
      }
    }
  }
}
</style>
